const normalizeBreadcrumb = (crumb) => {
  return {
    id: null,
    name: null,
    label: null,
    refinementKey: null,
    dimensionName: 'Category',
    ...crumb // what is needed from the breadcrumb??? :sob:
  };
};

export const processBreadcrumbs = (breadcrumbs = []) => {
  const categories = [];
  const refinements = [];
  if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
    return [categories, refinements];
  }
  breadcrumbs.forEach((crumb) => {
    if (crumb.dimensionName === 'Category') {
      categories.push(crumb.label);
    } else if (crumb.dimensionName === 'Review Rating' && crumb.label === '5') {
      refinements.push('Best Rated');
    } else if (crumb.label !== 'Home') {
      refinements.push(crumb.label);
    }
  });

  return [categories, refinements];
};

export const getDescription = (pageType, categories = [], refinements = [], searchVal) => {
  if (pageType !== 'b') return `Search Results for ${searchVal} at The Home Depot`;
  let refinedCategories = '';
  let department = '';

  if (categories.length > 0) {
    // THIS CODE WAS IN CANVAS BUT IT CONTRADICTS REQUIREMENTS FROM SEO
    // REMOVING IT BUT WE MIGHT NEED TO REVISIT IT.
    // condition added to check for browse/search page
    // if (categories.length === 4) {
    //   department = categories[categories.length - 2];
    // } else {
    //   [department] = categories;
    // }
    [department] = categories;
    if (categories.length === 1) {
      if (refinements.length > 0) {
        [refinedCategories] = refinements;
      } else {
        refinedCategories = categories[0];
      }
    } else if (categories.length >= 1) {
      const reverseRefinements = refinements.slice().reverse();
      refinedCategories = `${reverseRefinements.join(', ')} ${categories[categories.length - 1]}`.trim();
    }
  } else {
    refinedCategories = refinements.join(', ');
  }
  // eslint-disable-next-line max-len
  let description = `Get free shipping on qualified ${refinedCategories}`;
  if (!department) {
    description = `${description} products`;
  }
  description = `${description} or Buy Online Pick Up in Store today`;
  if (department) {
    description = `${description} in the ${department} Department`;
  }
  description = `${description}.`;
  return description;
};

export const getTitleTag = (pageType, categories = [], refinements = [], searchVal, pathWithQueryParams) => {
  let breadCrumbLabel = 'Browse';
  const isBrowseInSearch = pathWithQueryParams.indexOf('Ntt-') > -1;
  switch (pageType) {
  case 'b':
    // multiple pages indicates breadcrumbs that should be joined by ' - '
    if (isBrowseInSearch) {
      breadCrumbLabel = `Search Results for ${searchVal} at`;
    } else if (categories.length >= 0) {
      // only show up to two Category breadcrumbs
      const titleCategories = categories.slice().reverse().slice(0, 2);

      let bestRatedRatingIndex = refinements.indexOf('Best Rated');
      if (bestRatedRatingIndex !== -1) {
        let processedRefinements = refinements;
        processedRefinements[bestRatedRatingIndex] = 'Best Rated';
        breadCrumbLabel = `${[...processedRefinements.slice().reverse(), ...titleCategories].join(' - ')} -`;
      } else {
        breadCrumbLabel = `${[...refinements.slice().reverse(), ...titleCategories].join(' - ')} -`;
      }
    }
    return `${breadCrumbLabel} The Home Depot`;
  case 's':
    return `Search Results for ${searchVal} at The Home Depot`;
  default:
    return 'The Home Depot';
  }
};

export const getnValue = (canonical) => {
  if (!canonical) return null;
  const result = /N-(\w+)/.exec(canonical);
  if (result && result.length) {
    return result[1];
  }
  return null;
};

export const parseCrumbs = (crumbs = [], keyword, returnAll = false) => {
  if (keyword) {
    const textSearchCrumb = {
      url: '',
      label: 'Text Search'
    };

    let label;
    try {
      label = decodeURI(keyword);
    } catch (error) {
      label = keyword;
    }
    const keywordCrumb = {
      url: `/s/${keyword}?NCNI-5`,
      label
    };
    if (!crumbs.length) {
      crumbs.unshift(textSearchCrumb, keywordCrumb);
    } else {
      const textSearchCrumbIndex = crumbs.findIndex((crumb) => {
        return crumb.label === textSearchCrumb.label;
      });
      if (textSearchCrumbIndex === -1) {
        crumbs.unshift(textSearchCrumb, keywordCrumb);
      }
    }
  }
  if (crumbs.length > 0) {
    const hasCategory = crumbs.filter((crumb) => (crumb.dimensionName || '').toLowerCase() === 'category').length > 1;
    const breadcrumbs = hasCategory && !returnAll
      ? crumbs.filter((crumb) => (crumb.dimensionName || '').toLowerCase() === 'category')
      : crumbs.filter((crumb) => !crumb.deselectUrl);
    return breadcrumbs.map((crumb) => normalizeBreadcrumb(crumb));
  }
  return [];
};
